export default __webpack_public_path__ + "static/media/katana.e92d8e60.png";